<template>
  <div
    v-if="visible"
    class="tips-dialog-overlay"
    @touchmove.prevent
    @click.self="handleOverlayClick"
  >
    <div class="tips-dialog">
      <!-- 背景装饰图片 -->
      <img
        v-if="decorationImage"
        class="tips-dialog-decoration"
        :src="decorationImage"
        :style="decorationStyle"
        alt=""
      />
      <!-- 头部 -->
      <div class="tips-dialog-header" :style="headerStyle">
        <div
          v-if="showCloseIcon"
          class="tips-dialog-close"
          @click="handleClose"
        ></div>
        <div class="tips-dialog-title">{{ title }}</div>
      </div>

      <!-- 内容区域 -->
      <div class="tips-dialog-content">
        <slot>
          <div class="tips-dialog-message" :style="messageStyle" v-html="message"></div>
        </slot>
      </div>

      <!-- 底部按钮 -->
      <div class="tips-dialog-footer" v-if="showCancelButton || showConfirmButton">
        <div
          v-if="showCancelButton"
          class="tips-dialog-btn tips-dialog-btn-cancel"
          :style="cancelButtonStyle"
          @click="handleCancel"
        >
          {{ cancelButtonText }}
        </div>
        <div
          v-if="showConfirmButton"
          class="tips-dialog-btn tips-dialog-btn-confirm"
          :style="confirmButtonStyle"
          @click="handleConfirm"
        >
          {{ confirmButtonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TipsDialog',
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: false
    },
    // 标题
    title: {
      type: String,
      default: '温馨提示'
    },
    // 内容文字
    message: {
      type: String,
      default: ''
    },
    // 头部背景图片
    headerImage: {
      type: String,
      default: ''
    },
    // 是否显示关闭图标
    showCloseIcon: {
      type: Boolean,
      default: true
    },
    // 是否显示取消按钮
    showCancelButton: {
      type: Boolean,
      default: false
    },
    // 是否显示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    // 取消按钮文字
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    // 确认按钮文字
    confirmButtonText: {
      type: String,
      default: '确认'
    },
    // 点击遮罩层是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: false
    },
    // 内容文字样式
    messageStyle: {
      type: Object,
      default: () => ({})
    },
    // 取消按钮样式
    cancelButtonStyle: {
      type: Object,
      default: () => ({})
    },
    // 确认按钮样式
    confirmButtonStyle: {
      type: Object,
      default: () => ({})
    },
    // 背景装饰图片
    decorationImage: {
      type: String,
      default: ''
    },
    // 背景装饰图片样式
    decorationStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    headerStyle() {
      if (this.headerImage) {
        return {
          backgroundImage: `url(${this.headerImage})`
        }
      }
      return {}
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.lockBodyScroll()
      } else {
        this.unlockBodyScroll()
      }
    }
  },
  beforeDestroy() {
    this.unlockBodyScroll()
  },
  methods: {
    lockBodyScroll() {
      if (typeof document === 'undefined') return
      this._bodyOverflow = document.body.style.overflow
      this._bodyTouchAction = document.body.style.touchAction
      document.body.style.overflow = 'hidden'
      document.body.style.touchAction = 'none'
    },
    unlockBodyScroll() {
      if (typeof document === 'undefined') return
      document.body.style.overflow = this._bodyOverflow || ''
      document.body.style.touchAction = this._bodyTouchAction || ''
    },
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.handleClose()
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('update:visible', false)
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="less" scoped>
.tips-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.tips-dialog {
  width: 320px;
  border-radius: 8px;
  text-align: center;
  background: #FFFBF9;
  overflow: hidden;
  position: relative;
}

.tips-dialog-decoration {
  position: absolute;
  z-index: 1;
  pointer-events: none;
  width: 107px;
  height: 136px;
}

.tips-dialog-header {
  display: flex;
  justify-content: center;
  padding: 15px 24px 0;
  position: relative;
  background: url('~@/assets/images/dialogHeader.png') center center / 100% 100%;
}

.tips-dialog-close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  background: url('~@/assets/images/questionBank/no-passed-close-btn.png') center center / 100% 100%;
  z-index: 2;
}

.tips-dialog-title {
  font-size: 17px;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
  color: #000000;
  z-index: 1;
}

.tips-dialog-content {
  margin: 0;
  font-size: 15px;
  color: #000000;
}

.tips-dialog-message {
  padding: 30px 24px 20px;
  text-align: left;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  position: relative;
  z-index: 1;
}

.tips-dialog-footer {
  display: flex;
  justify-content: center;
  padding: 0 24px 20px;
  gap: 15px;
}

.tips-dialog-btn {
  min-width: 120px;
  height: 42px;
  line-height: 42px;
  border-radius: 42px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  text-align: center;
  z-index: 1;
}

.tips-dialog-btn-cancel {
  background: rgba(0, 0, 0, 0.08);
  color: #81766F;
}

.tips-dialog-btn-confirm {
  background: #EB1700;
  color: #fff;
}
</style>

<style lang="less">
/* 用于 v-html 内容的原子样式类（非scoped） */
.tips-dialog-message {
  .color-black-80 {
    color: rgba(0, 0, 0, 0.8);
  }

  .f-w-bold {
    font-weight: bold;
  }

  .f-w-400 {
    font-weight: 400;
  }

  .f-w-800 {
    font-weight: 800;
  }

  .f-s-14 {
    font-size: 14px;
  }

  .m-b-8 {
    margin-bottom: 8px;
  }
  .m-r-4 {
    margin-right: 4px;
  }
  .m-r-8 {
    margin-right: 8px;
  }
  .m-b-10 {
    margin-bottom: 10px;
  }
  .m-b-12 {
    margin-bottom: 12px;
  }
  .m-b-16 {
    margin-bottom: 16px;
  }
  .m-b-18 {
    margin-bottom: 18px;
  }
  .m-b-22 {
    margin-bottom: 22px;
  }
  .m-b-30 {
    margin-bottom: 30px;
  }

  .m-b-6 {
    margin-bottom: 6px;
  }

  .remind-icon {
    width: 20px;
    height: 20px;
    vertical-align: text-bottom;
  }

  .d-f {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TipsDialog/TipsDialog.vue